import { AutoComplete, Form, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import useApi from 'redux/api/api.hook';
import classes from './style.module.scss';

const { Option } = Select;

const categoryies = [
  'Deer (Antlered)',
  'Deer (Non Antlered)',
  'Hog',
  'Turkey',
  'People',
  'Vehicle',
  'Predator',
  'Other',
];

const ImageEditTag = (props) => {
  const [filteredTags, setFilteredTags] = useState<any[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTag, setSelectedTag] = useState('');
  const [assignCategory, setAssignCategory] = useState<any>(categoryies[0]);
  const [assignTag, setAssignTag] = useState<any>('');
  const { tags, tag_assigns } = useApi();

  const handleOk = () => {
    setIsModalVisible(false);
    props.onChangeTag(assignTag, assignCategory, 2);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    props.onChangeTag(assignTag, 'None', 2);
  };

  useEffect(() => {
    updateFilteredTags('');
  }, [tags, tag_assigns]);

  useEffect(() => {
    if (props.selectedTag) {
      setSelectedTag(props.selectedTag.split('$', 2).length > 1 ? props.selectedTag.split('$', 2)[1] : props.selectedTag);
    } else {
      setSelectedTag('');
    }
    updateFilteredTags('');
    console.log('selectedTag changed', props.selectedTag);
  }, [props.selectedImage, props.selectedTag]);

  const updateFilteredTags = (value) => {
    const resAssigned: any = [[]];
    const res: any = [];
    const resNone: any = [];
    if (!value || value == '') {
      res.push({ value: '-CLEAR-', className: 'None' });

      tags.forEach((element) => {
        if (element.tag !== '') {
          let flag_assigned = false;
          for (let i = 0; i < tag_assigns.length; i++) {
            const assign = tag_assigns[i];
            for (let j = 0; j < assign.value.length; j++) {
              if (assign.value[j] == element.tag) {
                if (resAssigned[assign.key] == undefined) {
                  resAssigned[assign.key] = [];
                }
                resAssigned[assign.key].push({ label: element.tag, className: assign.key, value: element.tag });
                flag_assigned = true;
                break;
              }
            }
            if (flag_assigned) { break; }
          }
          if (!flag_assigned) {
            resNone.push({ value: element.tag, className: 'None', key: element.tag });
          }
        }
      });
    } else {
      let newTag = true;
      tags.forEach((element) => {
        if (element.tag.toUpperCase().indexOf(value.toUpperCase()) === -1) { return; }
        if (element.tag.toUpperCase() == value.toUpperCase()) { newTag = false; }

        let flag_assigned = false;
        for (let i = 0; i < tag_assigns.length; i++) {
          const assign = tag_assigns[i];
          for (let j = 0; j < assign.value.length; j++) {
            if (assign.value[j] == element.tag) {
              if (resAssigned[assign.key] == undefined) {
                resAssigned[assign.key] = [];
              }
              resAssigned[assign.key].push({ label: element.tag, className: assign.key, value: element.tag });
              flag_assigned = true;
              break;
            }
          }
          if (flag_assigned) { break; }
        }
        if (!flag_assigned) {
          resNone.push({ value: element.tag, className: 'None', key: element.tag });
        }
      });
      if (newTag) {
        res.push({ value: `-NEW-${value}`, className: 'None' });
      }
    }

    categoryies.forEach((category) => {
      if (resAssigned[category] && resAssigned[category].length > 0) {
        res.push({ label: category, options: resAssigned[category] });
      }
    });

    if (resNone.length > 0) {
      res.push({ label: 'None', options: resNone });
    }
    setFilteredTags(res);
  };

  const tagSearch = (value) => {
    console.log('tagSearch');
    setSelectedTag(value);
    updateFilteredTags(value);
  };

  const tagChange = (value, option) => {
    console.log('tagChange');
    if (value == '-CLEAR-') {
      props.onChangeTag('', option.className, 1);
    } else if (value.indexOf('-NEW-') > -1) {
      setAssignTag(value.substring(5));
      setIsModalVisible(true);
    } else {
      props.onChangeTag(value, option.className, 0);
    }
  };

  return (
    <>
      <AutoComplete
        value={selectedTag}
        onSelect={tagChange}
        onSearch={tagSearch}
        placeholder="Change Tag To:"
        dropdownStyle={{ position: 'fixed' }}
        options={filteredTags}
      />
      <Modal
        title="Assign A Category"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form.Item name="tag" className={classes.formInputWrapper} initialValue={categoryies[0]}>
          <Select size="large" placeholder="Deer (Antlered)" onChange={(value) => setAssignCategory(value)} dropdownStyle={{ position: 'fixed' }}>
            {categoryies.map((val, i) => (
              <Option key={i} value={val}>{val}</Option>
            ))}
          </Select>
        </Form.Item>
      </Modal>
    </>
  );
};

export default ImageEditTag;
